import { OrderHistory as IOrderHistory, UserOrderDetails } from '../../order-history/order-history.interface';
import { ariaLabelWithNewTab } from '../../../common/utils/a11y-util';
import { html, TemplateResult } from 'lit';
import { getClinicalReasoningAppUrl } from '../../../common/constants/professional-redirects';

export const CR_LAUNCH_CTA_LABEL = 'Launch Clinical Reasoning';

/**
 * Opens Clinical Reasoning in a new window
 *
 * @param event
 * @param order
 * @param userOrderDetails
 * @param analyticsCallback
 */
function openClinicalReasoningApp(
  event: Event,
  order: IOrderHistory,
  userOrderDetails: UserOrderDetails,
  analyticsCallback: Function
): void {
  event?.preventDefault();
  const url = getClinicalReasoningAppUrl();
  analyticsCallback('go-to-clinical-reasoning', 'Launch', order, userOrderDetails, url);
  window.open(url);
}

/**
 * Clinical Reasoning CTA for digital products and order history sections
 *
 * @param order
 * @param userOrderDetails
 * @param analyticsCallback
 */
export function getClinicalReasoningLaunchCta(
  order: IOrderHistory,
  userOrderDetails: UserOrderDetails,
  analyticsCallback: Function
): TemplateResult {
  return html` <a
    class="btn btn-outline-primary w-100 w-lg-75"
    aria-label="${ariaLabelWithNewTab('Clinical Reasoning App')}"
    target="_blank"
    data-automation-id="btn-launch-${order.webOrderNo}-${userOrderDetails.isbn10}"
    @click=${(event: Event): void => openClinicalReasoningApp(event, order, userOrderDetails, analyticsCallback)}
    href="#"
  >
    ${CR_LAUNCH_CTA_LABEL}&nbsp;
    <uxt-icon icon="box-arrow-up-right"></uxt-icon>
  </a>`;
}
